export default __webpack_public_path__ + "static/media/golddice-img.3afe086a.webp";